import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { Toolbox } from "../components/PageSkeleton/Toolbox";

export const Template = (props: templates.ContentPageTemplate) => (
    <PageSkeleton {...props.page} isPreview={props.is_preview}>
        <Toolbox value={props.page.body.value} />
    </PageSkeleton>
);
